/* ==========================================================================
 *  Function: Dropdown
 * ======================================================================= */
function fn_parts_dropdown(){
	if ($( '.js-dropdown-trigger' ).length && $(window).width() < bp_medium){
		$( '.js-dropdown-trigger' ).on( 'click' , function () {
			$(this).closest( '.js-dropdown-block' ).toggleClass( class_active );

			// if ($( '.navigation.is-collapse' ).length){
			// 	$( '.navigation.is-collapse' ).removeClass( 'is-collapse' );
			// }
		});
	}

	if ($( '.menu-list-item.js-dropdown-block-full' ).length && $(window).width() > bp_medium){
		$( '.menu-list-item.js-dropdown-block-full' ).hover(
			function() {
				$(this).addClass(class_active);
				$( '.modal-overlay' ).addClass( class_active );
				$( 'body' ).addClass( 'overflow-hidden' );
			}, function() {
				$(this).removeClass(class_active);
				$( '.modal-overlay' ).removeClass( class_active );
				$( 'body' ).removeClass( 'overflow-hidden' );
		});
	}
}